import { get, post } from '.';

export function GetOptInOuts(options = {}) {
	return get<any>("/app/api/opt_in_outs", options);
}

export function CreateOptInOut(options = {}) {
	return post<any>("/app/api/opt_in_outs", options);
}

export function ResubscribeOptInOuts(options = {}) {
	return post<any>("/app/api/opt_in_outs/resubscribe", options);
}